import Phaser from "phaser";

// src/AnimationView/engine/utils/physics.ts
export function setArcadeBodySize(
    sprite: Phaser.Types.Physics.Arcade.SpriteWithDynamicBody | Phaser.GameObjects.Image,
    displayW: number,
    displayH: number,
    origin: "topLeft" | "center" = "center"
) {
    const body = sprite.body as Phaser.Physics.Arcade.Body | undefined;
    if (!body) return;

    // Convert desired display size to unscaled body size
    const sx = sprite.scaleX || 1;
    const sy = sprite.scaleY || 1;
    const unscaledW = displayW / sx;
    const unscaledH = displayH / sy;

    body.setSize(unscaledW, unscaledH, false);

    if (origin === "topLeft") {
        body.setOffset(0, 0);
    } else {
        // center: offset so the body centers on the texture
        body.setOffset(-unscaledW / 2, -unscaledH / 2);
    }
}
